import { FC } from "react"
import BarCardComponentProps from "./line_card_component_props"
import { Line } from "react-chartjs-2";
import { colorsForDashboard, getColorForDashboard } from "../../../../utils/general_utils";

const LineCardComponent: FC<BarCardComponentProps> = ({ data, title, yTitle }) => {
    const _parsedChartData = (): {
        labels: string[],
        datasets: {
            data: number[],
            backgroundColor: string[] | string
        }[]
    } => {
        const labels = data!.map(item => item.label);
        const datasets = [{
            data: data!.map(day => day.value),
            backgroundColor: colorsForDashboard[2] + "aa",
            fill: true,
        }];

        return {
            labels,
            datasets
        }
    }

    return <div className="bar_card_component">
        <h5 className="mb-3">{title}</h5>
        <Line data={_parsedChartData()}
            options={{
                plugins: {
                    legend: {
                        display: false,
                        position: 'bottom',
                    },
                },
                responsive: true,
                scales: {
                    y: yTitle !== undefined ? {
                        title: {
                            display: true,
                            text: yTitle
                        }
                    } : {}
                },
            }} />
    </div>
}

export default LineCardComponent